import Vue from 'vue'
import Vuex from 'vuex'
import layout from './layout'
import createPersistedState from 'vuex-persistedstate'
import SecureLS from 'secure-ls'
const ls = new SecureLS({ isCompression: false })
import { DefineDastresi } from '../pages/BnpSys/Store/StoreDefineDastresi'
import { TarifKarbaran } from '../pages/BnpSys/Store/StoreTarifKarbaran'
import { DefineInfoSystem } from '../pages/BnpSys/Store/StoreDefineInfoSystem'
Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    IsActiveCash: null,
    FilterContractReminderReport: {},
    tblCustomerId: 0,
    activeTab: null,
    SanadRizNew: {
      Data: [
        {
          Id: 0,
          TblDoreId: 203597,
          TblComboIdNoeSanad5: 4004,
          TblComboIdNoeSanadAuto21: 0,
          ShomareSanadEslahi: 0,
          ShomareSanad: 0,
          OrderSanad: 0,
          TarixSanad: '',
          SharhSanad: 'سند موقت',
          Done: 0,
          IsAuto: 0,
          ZamanInsert: '',
          TblUserGrpIdInsert: 1,
          ZamanLastEdit: '',
          TblUserGrpIdLastEdit: 0,
          InfoDes: '',
          SanadNoMakos: 0,
          SanadNoCopy: 0,
          ChidanAghsat: 0,
          DonotSendSms: 0,
          TblSanadIdMakos: 0,
          TblSanadIdMakosShode: 0,
        },
      ],
      EditData: [{}],
      EmptyRow: [
        {
          ShowJoze: false,
          Id: '',
          tblSanadId: '',
          tblSarfaslId: '',
          Vcode: '',
          tblTaahodatId: '',
          tblTaahodatRizId: null,
          tblAzaIdTafsili: null,
          SharhSanadRiz: '',
          Bestan: '0',
          Bedeh: '0',
          BedBes: 0,
          DesSanadRiz: null,
          FishNoRahgiri: null,
          NameFamily: '',
          ShomareOzv: '',
          WithJoze: false,
          Taahodtxt: '',
          tblChkSareHesabId: null,
          tblCheckVaDaftarcheMoshtariRizId: null,
          tblCheckBankiRizId: null,
          SerialCheckBanki: null,
          SerialChkSarHesab: null,
          SerialCheckMoshtari: null,
          CodeSarfasl: '120102',
          CodeSarfasl2: '12',
          ZamanInsert: '1399/10/10 08:55:30',
          Done: true,
          tblAzaId: 201857,
          tblComboIdNahvePardaxt29: null,
          tblComboIdNoeSanad5: null,
          ShomareSanad: null,
          TarixSanad: '',
          SharhSanad: '',
          tblSanadIdSodVaZian: null,
          tblSanadIdEftetahie: null,
          tblSanadIdExtetamie: null,
          tblComboIdVaziyat17: '',
          TblSarfaslTypeId: null,
          tblAsnadZemanatiId: null,
          IsUserDeleted: false,
          tblTaahodatIdMortabet: null,
          VCodeMortabet: null,
          tblTaahodatIdEnteghalSarfasl: null,
          TarixCheckBanki: null,
          tblCheckMoshtariId: null,
          tblCheckMoshtariId2: null,
          tblShobeId: 1,
          Varizkonande: null,
          tblTaahodatIdKarmozd: null,
          SahebKarmozd: null,
          SharhSarfaslGoroh: '',
          SharhSarfaslKol: '',
          CodeKol: '1201',
          SharhSarfaslMoein: '',
          CodeMoein: '120102',
          SharhCodeSarfaslJoze: '',
          SharhSarfaslJoze: '',
          CodeSarfaslJoze: '',
        },
      ],
      DataAdd: [
        {
          Id: 0,
          tblSanadId: 0,
          SharhSanadRiz: '',
          tblTaahodatId: 0,
          Bedeh: 0,
          FishNoRahgiri: '',
          Bestan: 0,
          tblAzaIdTafsili: 0,
          tblTaahodatRizId: 0,
          Varizkonande: '',
          tblCheckVaDaftarcheMoshtariRizId: 0,
          tblChkSareHesabId: 0,
          tblTaahodatIdKarmozd: 0,
          TarixCheckBanki: '',
          tblTaahodatIdMortabet: 0,
          tblSarfaslId: 0,
          tblCheckBankiRizId: 0,
          tblComboIdNahvePardaxt29: 0,
          DesSanadRiz: '',
          ZamanInsert: '',
          tblUserGrpIdInsert: 0,
        },
      ],
    },

    SearchTaahod: { Data: [] },
    DoreMaliData: [],
    SarfaslHayeMojaz: [],
    DoreMaliData: [],
    FrmDaryaft: {
      DataSearchVcode: [],
      DataSabtDaem: [
        {
          b_Stop: 0,
          b_SmSiSendShod: 0,
          RunCompilite: 1,
          b_SanadId: 0,
          b_ShomareSanad: 0,
          b_ErrorMsg: null,
        },
      ],
      ShowDataSanad: [{}],
      Data: [{ TarixSanad: '', TblSarfaslIdBankTarafHesab: 0, ChandGane: false, b_sarId: 0, TblBabkIdTaraf: 0, TblBankIdTarkibi: 0, TaahodatId: 0, b_NoePerf: 0 }],
    },
    TanzimatPublic: [],
    b_SabtSandDaem: null,
    JalaliDate: '',
    loading: false,
    JalaliTime: '',
    OldDataForLog: [],
    ListUserGrpMenu: {},
    VersionSoftware: '1.1.0102',
    counterSharj: '',
    marketingReportFilter: {},
    LastLoginTime: '',
    columns: [],
    CustomerTicketFilters: { Grp41: [1791, 1792, 1794, 1795, 1797, 1798, 1793, 1841]},
    // موقع خروج از سایت مقادیر در لیوت ریست میشود
    TickCPFilter: { value: [1791, 1793, 1794, 1795, 1797, 1798, 1841, 1842], value2: [], value3: [], value4: [], customerId: null },
    TicketReportFilter: { TarixAz: null, TarixTa: null, departmentList: [], tblUserList: [], ticketTypeList45: [], TicketStatus41: [] },
    FilterdTickets: [],
    renderComponentGrid: true,
    renderComponentTicket: true,
    renderComponentCombo: true,
    renderComponentCard: true,
    renderComponentSort: true,
    renderComponent: true,
    renderProfile: true,
    GetUserDatails: [],
    TblComboGrpId45: [],
    TblComboGrpId41: [],
    TblComboGrpId42: [],
    GetCostomerProduct: [],
    ComponentInToModal: { Frm: '' },
    ThemeLight: false,
    objectLogInformation: {
      UserId: 0,
      FkId: 0,
      IsDelete: 0,
      ZamanLog: '',
      MasterLink: '',
      MasterTable: '',
      FormName: '',
      Shenase: null,
      UserNameFamily: '',
      FormId: '',
      tblShobeId: 0,
      MacAddress: '',
      IpAddress: '',
      TblBnpCashLogRiz: [],
    },
    elmAccess: [],
    Customer: [],
    DetailBedehiCustomer: [],
    ContractSearch: {},
    ContractModel: {},
    Modal: false,
    ContractSerachToEdit: false,
    SeenWorkTip: false,
    title: 'سامانه جامع (CRM) شرکت پاسارگاد',
    MarketingReportFilter: {
      tblCombogrp9RaveshBazaryabi: null,
      tblCombogrp22ManbaBazaryabi: null,
      tblCombogrp3Group: null,
      tblCombogrp4AvalinHadafBazaryabi: null,
      tblCombogrp11Shahr: null,
      tblCombogrp10state: null,
      tblCombogrp37AxarinVazeit: null,
      Archive: null,
      OnlyCustomers: true,
    },
    CustomerTicketSortAndPage: {
      sortAsc: null,
      sortName: null,
      Page: null,
      PageNationNamber: null,
    },
  },
  plugins: [
    createPersistedState({
      storage: {
        getItem: (key) => ls.get(key),
        setItem: (key, value) => ls.set(key, value),
        removeItem: (key) => ls.remove(key),
      },
    }),
  ],
  getters: {
    getVersionSoftware: (state) => {
      return state.VersionSoftware
    },
    GetCostomerProduct(state) {
      return state.GetCostomerProduct
    },
    GetTblComboGrpId42(state) {
      return state.TblComboGrpId42
    },
    GetTblComboGrpId41(state) {
      return state.TblComboGrpId41
    },
    GetTblComboGrpId45(state) {
      return state.TblComboGrpId45
    },
    GetUserDatails(state) {
      return state.GetUserDatails
    },
  },
  mutations: {
    myCustomerId(state, value) {
      state.tblCustomerId = value
    },
    myactiveTab(state, value) {
      state.activeTab = value
    },
    UpdateColGrid(state, columns) {
      state.columns = columns
    },
    myVersionSoftware(state, value) {
      state.VersionSoftware = value
    },
    myJalaliDate(state, Date) {
      state.JalaliDate = Date
    },
    myJalaliTime(state, Time) {
      state.JalaliTime = Time
    },
    myJalaliTime(state, Time) {
      state.JalaliTime = Time
    },
    myemptyCombo(state, value) {
      if (value == null) {
        state.TblComboGrpId45 = []
        state.GetCostomerProduct = []
        state.TblComboGrpId41 = []
        state.TblComboGrpId42 = []
        state.setDefaultval = []
      }
    },
    SetCostomerProduct(state, value) {
      state.GetCostomerProduct = value
    },
    SetTblComboGrpId42(state, value) {
      state.TblComboGrpId42 = value
    },
    SetTblComboGrpId41(state, value) {
      state.TblComboGrpId41 = value
    },
    SetTblComboGrpId45(state, value) {
      state.TblComboGrpId45 = value
    },
    SetUserDatails(state, value) {
      state.GetUserDatails = value
    },
  },
  actions: {
    SetCoolGrid({ commit }, columns) {
      commit('UpdateColGrid', columns)
    },
    setCustomerId({ commit }, value) {
      commit('myCustomerId', value)
    },
    setactiveTab({ commit }, value) {
      commit('myactiveTab', value)
    },
  },
  modules: {
    layout: layout,
    DefineDastresi: DefineDastresi,
    TarifKarbaran: TarifKarbaran,
    DefineInfoSystem: DefineInfoSystem,
  },
})
